<h5 *ngIf="label" [ngClass]="labelClass" class="label">{{ label }}</h5>
<div class="wrapper">
    <ng-container *ngIf="!scanningEnabled;else withScanning">
        <ng-container *ngIf="!loading; else loadingAnimation">
            <ng-container *ngTemplateOutlet="displayOnly"></ng-container>
        </ng-container>
    </ng-container>
</div>

<ng-template #displayOnly>
    <ng-container *ngIf="shouldRenderItems();else emptyMessageTemplate">
        <ng-container *ngTemplateOutlet="displayTree"></ng-container>
    </ng-container>
</ng-template>

<ng-template #withScanning>
    <div appBadgeScanner
         [isScanListenerActive]="isScanListenerActive"
         (scan)="triggerScanEvent($event)">
    </div>
    <ng-container *ngIf="shouldRenderItems();else emptyMessageTemplate">
        <ng-container *ngTemplateOutlet="scanTree"></ng-container>
    </ng-container>
</ng-template>

<ng-template #displayTree>
    <p-tree id="tree"
            [loading]="loading"
            [value]="items">
        <ng-template let-node pTemplate="default">
            <div class="node-label">
                <div class="node-title" [innerText]="node.label" type="text" #contextModel></div>
                <app-icon *ngIf="getLeafActionIcon(node) as actionIcon"
                          library="material"
                          simple="true"
                          [variant]="actionIcon"
                          (click)="onParameterIconClick(node.data)">
                </app-icon>
            </div>
            <div class="entry">
                <ng-container *ngFor="let parameter of parameters; let i = index">
                    <div class="parameters" *ngIf="getValue(node, parameter) as nodeValue">
                        <span class="entry-detail"
                              [innerHTML]="parameter.label | translate : { value: nodeValue}"> </span>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </p-tree>
</ng-template>


<ng-template #scanTree>
    <p-tree [value]="items"
            selectionMode="checkbox"
            [loadingIcon]=""
            [loading]="loading"
            (onNodeSelect)="nodeSelect($event)"
            (onNodeUnselect)="nodeUnselect($event)"
            [propagateSelectionUp]="propagateSelectionUp"
            [propagateSelectionDown]="propagateSelectionDown"
            [(selection)]="_selectedItems">
        <ng-template let-node pTemplate="default">
            <div class="entry" [innerText]="node.label" type="text" #contextModel></div>
        </ng-template>
        <ng-template let-node pTemplate="tool-inspect">
            <div class="tree-inspect-row entry">
                <div class="inspect-label" [ngClass]="{'striked': node.inspected}">{{ node.label }}</div>
                <span class="inspect-warning-wrapper" (click)="clickRowAlert(node)">
                    <app-icon *ngIf="node.warning"
                              [simple]="true"
                              library="material"
                              type="danger"
                              variant="warning">
                    </app-icon>
                </span>
            </div>
        </ng-template>
    </p-tree>
</ng-template>

<ng-template #emptyMessageTemplate>
    <span class="empty-message">{{ emptyMessage }}</span>
</ng-template>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
